// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3D9-A","rootNoMargin":"styles_rootNoMargin__3XCX5"};